module.exports = __webpack_public_path__ + "img/rca-expand.d3b778aa.svg";